import { User } from "@/models/user.model";
import apiClient from "./apiClient";
import { StaffInfo, StaffInfoDTO } from "@/models/staff-info.model";
import { getUTCDate } from "@/utils/date-format";

export const getStaffInfoByUserId = async (
  userId: number
): Promise<StaffInfoDTO> => {
  const res = await apiClient.get(`/users/${userId}/staff-info`);
  const data: StaffInfoDTO = res.data as StaffInfoDTO;
  return data;
};

export const updateStaffInfoByStaffInfoId = async (
  id: number,
  args: {
    gender?: string;
    dateOfBirth?: Date;
    nationality?: string;
    race?: string;
    nric?: string;
  }
): Promise<StaffInfo> => {
  const res = await apiClient.patch(`/staff-info/${id}`, {
    ...args,
    dateOfBirth: args.dateOfBirth ? getUTCDate(args.dateOfBirth) : undefined,
  });
  const data: StaffInfo = res.data as StaffInfo;
  return data;
};

export const updateStaffInfoByUserId = async (
  userId: number,
  args: {
    gender?: string;
    dateOfBirth?: Date;
    nationality?: string;
    race?: string;
    nric?: string;
  }
): Promise<StaffInfo> => {
  const res = await apiClient.patch(`/users/${userId}/staff-info`, {
    ...args,
    dateOfBirth: args.dateOfBirth ? getUTCDate(args.dateOfBirth) : undefined,
  });
  const data: StaffInfo = res.data as StaffInfo;
  return data;
};
